import { testProps } from './common';
import * as TestAppId from './enums/index';

export { testProps, TestAppId };
